import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addScoreItem from './component/addScoreItem.vue';
import uploadImagetow from '@/components/uploadImagetow';
import { pageSize } from '@/mixins/index';
export default {
  name: "scoreList",
  components: {
    uploadImagetow: uploadImagetow,
    addScoreItem: addScoreItem
  },
  props: ['eventId'],
  mixins: [pageSize],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      delIds: [],
      // 用于跟踪选中的学生ID及其对应的行
      selectedStudentMap: new Map(),
      // 防止递归选中的标志
      isSelecting: false,
      value2: []
    };
  },
  created: function created() {
    this.getList(1);
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.paramsData.start_time = this.value2[0];
        this.paramsData.end_time = this.value2[1];
      } else {
        this.paramsData.start_time = '';
        this.paramsData.end_time = '';
      }
    },
    processTableData: function processTableData(data) {
      // 如果没有数据，直接返回空数组
      if (!data || !Array.isArray(data) || data.length === 0) {
        return [];
      }

      var studentMap = new Map();
      var processedData = []; // 第一步：找出每个学生最新的记录

      data.forEach(function (item) {
        var studentId = item.student_id;
        var currentSubmittedAt = new Date(item.submitted_at).getTime();

        if (!studentMap.has(studentId) || currentSubmittedAt > new Date(studentMap.get(studentId).submitted_at).getTime()) {
          studentMap.set(studentId, item);
        }
      });
      data.forEach(function (item) {
        var latestItem = studentMap.get(item.student_id);
        item.canEdit = latestItem && latestItem.id === item.id;
        processedData.push(item);
      });
      return processedData;
    },
    getList: function getList(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.paramsData.page = page;

                _this.$api.scoreDetailList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  event_id: _this.eventId
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.student_name = item.student.name;

                      if (item.format_time != '0') {
                        item.duration = item.format_time;
                      } else {
                        item.duration = _this.$utils.formatDuration(item.duration);
                      }
                    });
                    _this.tableData = _this.processTableData(data);
                    console.log("this.tableData", _this.tableData);
                    _this.total = res.data.total;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    del: function del(dateList) {
      var _this2 = this;

      // 去重：获取选中的学生ID（去重）
      var uniqueStudentIds = _toConsumableArray(new Set(dateList.map(function (item) {
        return item.student_id;
      })));

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u5220\u9664\u9009\u4E2D\u7684 ".concat(uniqueStudentIds.length, " \u4E2A\u5B66\u751F\u7684\u6240\u6709\u6210\u7EE9\u8BB0\u5F55, \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.scoreDetailDelete({
                  student_ids: uniqueStudentIds,
                  event_id: _this2.eventId
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("删除成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this3 = this;

      this.columns = [{
        label: '学生ID',
        prop: 'student_id'
      }, {
        label: '学生姓名',
        prop: 'student_name'
      }, {
        label: '使用的激活码',
        prop: 'activation_code'
      }, {
        label: '比赛分数',
        prop: 'score'
      }, {
        label: '比赛时长',
        prop: 'duration'
      }, {
        label: '客户端上报时间',
        prop: 'submitted_at'
      }];
      this.$api.scoreDetailList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        event_id: this.eventId,
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.student_name = item.student.name;
            item.duration = _this3.$utils.formatDuration(item.duration);
          });

          _this3.$export.excel({
            columns: _this3.columns,
            data: data,
            title: '成绩明细'
          });
        }
      });
    }
  }
};